import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 80;

function MoneyIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON_SIZE}
      height={ICON_SIZE}
      className={className}
    >
      <g transform="translate(7 13)" fill="none">
        <circle cx={27} cy={21} r={21} fill="#E8E8E8" />
        <path
          fill="#212121"
          d="M13.735 30.907a2.985 2.985 0 01-5.625 0H2v21.814h6.11a2.984 2.984 0 015.625 0h33.893V36.814H17.372a1 1 0 01-1-1v-4.907h-2.637zm4.637 3.907h30.256a1 1 0 011 1v17.907a1 1 0 01-1 1H12.907a1 1 0 01-1-1 .984.984 0 10-1.969 0 1 1 0 01-1 1H1a1 1 0 01-1-1V29.907a1 1 0 011-1h7.938a1 1 0 011 1 .983.983 0 101.969 0 1 1 0 011-1h4.465a1 1 0 011 1v4.907z"
        />
        <path
          fill="#212121"
          d="M9.922 36.364a1 1 0 012 0v3a1 1 0 11-2 0v-3zm0 8a1 1 0 012 0v3a1 1 0 11-2 0v-3zm22.342 5.388a1 1 0 01-2 0V37a1 1 0 112 0v12.752zm-3.474-3.721a1 1 0 11-2 0V37a1 1 0 012 0v9.031zm13.877-9.279a1 1 0 112 0v13a1 1 0 01-1 1h-7.938a1 1 0 01-1-1v-13a1 1 0 112 0v12h5.938v-12z"
        />
        <path
          fill="#212121"
          d="M18.372 13v21.814H64V13H18.372zm-1-2H65a1 1 0 011 1v23.814a1 1 0 01-1 1H17.372a1 1 0 01-1-1V12a1 1 0 011-1z"
        />
        <path
          fill="#212121"
          d="M41.186 30.86a6.953 6.953 0 010-13.907 6.954 6.954 0 110 13.907zm0-2a4.953 4.953 0 10.002-9.906 4.953 4.953 0 00-.002 9.906zm-14.388-1.969a2.984 2.984 0 110-5.968 2.984 2.984 0 010 5.968zm0-2a.984.984 0 10.002-1.968.984.984 0 00-.002 1.968zm-9.426-4.449a1 1 0 010-2A6.442 6.442 0 0023.814 12a1 1 0 012 0 8.442 8.442 0 01-8.442 8.442zm39.186-8.444a1 1 0 012 0A6.442 6.442 0 0065 18.44a1 1 0 010 2 8.442 8.442 0 01-8.442-8.442zM25.814 35.814a1 1 0 01-2 0 6.442 6.442 0 00-6.442-6.442 1 1 0 010-2 8.442 8.442 0 018.442 8.442zm39.188-8.442a1 1 0 010 2 6.442 6.442 0 00-6.442 6.442 1 1 0 01-2 0 8.442 8.442 0 018.442-8.442zm-9.924-.481a2.984 2.984 0 11-.002-5.968 2.984 2.984 0 01.002 5.968zm0-2a.984.984 0 100-1.968.984.984 0 000 1.968z"
        />
      </g>
    </svg>
  );
}

MoneyIcon.propTypes = {
  className: PropTypes.string,
};

MoneyIcon.ICON_SIZE = ICON_SIZE;

export default MoneyIcon;
